module.exports = __webpack_public_path__ + "static/media/t1.183477b2.svg";